import type { Testimonial } from '../types/testimonial'

export const testimonials: Testimonial[] = [
  {
    id: 'lucia',
    name: 'Lucía M.',
    age: 34,
    city: 'Madrid, España',
    headline: 'Mi cara volvió a ser la de antes',
    quote:
      'Pensé que era grasa. En 4 días con el suero adrenal y la luz solar, mi cara volvió a ser la de antes. Increíble.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f04bc322-c4fd-4c0b-b01d-bf4591d1fd17.jpg',
    date: '12 de febrero de 2026',
  },
  {
    id: 'mariana',
    name: 'Mariana R.',
    age: 41,
    city: 'CDMX, México',
    headline: 'Mis anillos volvieron a entrar',
    quote:
      'Bajé 3 kilos de pura agua en una semana. Mis anillos volvieron a entrar. La paz mental no tiene precio.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/08f15884-3cd1-40b4-b58a-2f4f6f19f616.jpg',
    date: '3 de febrero de 2026',
  },
  {
    id: 'elena',
    name: 'Elena T.',
    age: 38,
    city: 'Miami, EE. UU.',
    headline: 'Adiós al bajón de las 3 PM',
    quote:
      'El hack de "Proteína antes que Café" cambió mi vida. Ya no tengo el bajón de las 3 PM ni la panza hinchada al cenar.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/b1bbaab5-110d-409e-bfce-fe2bd5b88fc0.jpg',
    date: '28 de enero de 2026',
  },
  {
    id: 'patricia',
    name: 'Patricia G.',
    age: 45,
    city: 'Bogotá, Colombia',
    headline: 'Más plano que tras meses de gym',
    quote:
      'Por fin alguien que explica que el HIIT me estaba enfermando. Llevo 10 días y mi abdomen está más plano que tras meses de gym.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e538ff3f-28b5-4e25-86f9-2ab7b0e51482.jpg',
    date: '24 de enero de 2026',
  },
  {
    id: 'sofia',
    name: 'Sofía B.',
    age: 31,
    city: 'Buenos Aires, Argentina',
    headline: 'El Protocolo 20-20 es simple y potente',
    quote:
      'Increíble cómo algo tan simple como el Protocolo 20-20 puede deshincharte tanto después de comer.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/95df9f20-73c9-4fc2-8371-588d8cf70306.jpg',
    date: '19 de enero de 2026',
  },
  {
    id: 'valeria',
    name: 'Valeria C.',
    age: 39,
    city: 'Santiago, Chile',
    headline: 'La niebla mental desapareció',
    quote:
      'La niebla mental desapareció al segundo día. Dormir con el "Vaciado Mental" es otro nivel.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/25a125f3-b8ef-4c2c-82c6-c2188c4bd48a.jpg',
    date: '15 de enero de 2026',
  },
  {
    id: 'claudia',
    name: 'Claudia V.',
    age: 52,
    city: 'Barcelona, España',
    headline: 'Creí que era la menopausia. Era cortisol.',
    quote:
      'Creí que era la menopausia. Era cortisol. Mi cuerpo se siente ligero por primera vez en años.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/febd9c7f-79b0-4e40-9e69-fe930845e4c7.jpg',
    date: '11 de enero de 2026',
  },
  {
    id: 'raquel',
    name: 'Raquel A.',
    age: 37,
    city: 'Lima, Perú',
    headline: 'La mejor inversión de $19',
    quote:
      'La mejor inversión de $19. Directo al grano, sin rellenos. Los resultados se ven en el espejo cada mañana.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/86be4bb7-cc2a-4f11-93d1-26421d946a57.jpg',
    date: '8 de enero de 2026',
  },
  {
    id: 'beatriz',
    name: 'Beatriz L.',
    age: 43,
    city: 'Valencia, España',
    headline: 'Mi esposo notó mi cara',
    quote:
      'Mi esposo me preguntó qué me había hecho en la cara, que me veía más joven. Solo bajé la inflamación.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/989be7d9-59e2-4992-b7ac-c29ab92b3895.jpg',
    date: '5 de enero de 2026',
  },
  {
    id: 'monica',
    name: 'Mónica P.',
    age: 36,
    city: 'Quito, Ecuador',
    headline: 'Recuperé el control del apetito',
    quote:
      'Ya no tengo antojos de sal por la tarde. El Código Cortisol me devolvió el control de mi apetito.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/97c5b5d3-89b2-43b4-a55a-14b2ba1f9f00.jpg',
    date: '2 de enero de 2026',
  },
  {
    id: 'gabriela',
    name: 'Gabriela H.',
    age: 40,
    city: 'San José, Costa Rica',
    headline: 'Soy médico y la cronobiología es impecable',
    quote:
      'Soy médico y confirmo: la cronobiología aquí aplicada es impecable. Un manual necesario.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c53a6e0c-366c-40d6-be32-e08d4570c74e.jpg',
    date: '29 de diciembre de 2025',
  },
  {
    id: 'isabel',
    name: 'Isabel N.',
    age: 48,
    city: 'Houston, EE. UU.',
    headline: 'Mis zapatos me quedan grandes',
    quote:
      'Drené tanta inflamación en los tobillos que mis zapatos me quedan grandes. Magia biológica.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3d7d9581-e0da-4167-8be6-c2e78b013337.jpg',
    date: '22 de diciembre de 2025',
  },
  {
    id: 'natalia',
    name: 'Natalia S.',
    age: 33,
    city: 'Medellín, Colombia',
    headline: 'La respiración vagal es mi botón de emergencia',
    quote:
      'La técnica de respiración vagal es mi botón de emergencia. Adiós a la hinchazón por estrés.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7ba6f0b1-6993-4945-87e8-1c1e024d1dfc.jpg',
    date: '18 de diciembre de 2025',
  },
  {
    id: 'sandra',
    name: 'Sandra E.',
    age: 44,
    city: 'Asunción, Paraguay',
    headline: 'Los 7 días más reveladores de mi vida',
    quote:
      'Sin dietas locas. Solo entendiendo mi reloj interno. Los 7 días más reveladores de mi vida.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/413d6a76-a5a4-4e63-a21d-93872c900ae4.jpg',
    date: '14 de diciembre de 2025',
  },
  {
    id: 'paola',
    name: 'Paola D.',
    age: 39,
    city: 'Montevideo, Uruguay',
    headline: 'Si estás dudando, hazlo',
    quote: 'Si estás dudando, hazlo. En 60 días puedes ser otra persona. Yo lo soy.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/49b6e129-8384-43f9-bc18-217788851d15.jpg',
    date: '9 de diciembre de 2025',
  },
]
